export const config = {
  getMyCollege: "https://api.coldpressedoils.in",
  apiUrl: "https://api.coldpressedoils.in",
  // getMyCollege: "http://localhost:8080",
  // apiUrl: "http://localhost:8080",
  cookieName: "org_user",
  sessionCookie: "org_sess",
};